import { lazy, Suspense } from 'react';
import { ImageComparerProps } from './interfaces';

// Lazy load ImageComparer to reduce initial bundle (includes Konva ~183KB gzip)
const ImageComparerComponent = lazy(() => import('./ImageComparer').then(mod => ({ default: mod.ImageComparer })));

// Fallback component while ImageComparer is loading
function ImageComparerFallback({ width = '100%', height = '500px' }: { width?: string | number; height?: string | number }) {
  return (
    <div 
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.05)',
        borderRadius: '4px'
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-2" role="status">
          <span className="visually-hidden">Loading image comparer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading image comparer...</div>
      </div>
    </div>
  );
}

export function ImageComparerLazy(props: ImageComparerProps) {
  return (
    <Suspense fallback={<ImageComparerFallback width={props.width} height={props.height} />}>
      <ImageComparerComponent {...props} />
    </Suspense>
  );
}

export default ImageComparerLazy;
